import { endpoints } from '../api/sharedEndpoints';
import type { GameCreateRequest, GameDto, GameImportDto, GameTagDto, GameUpdateRequest, GamesListResponse } from '../api/types';

export interface GamesRepository {
  listGames(params?: { name?: string; tags?: string[] }): Promise<GamesListResponse>;
  getGame(params: { gameId: string }): Promise<GameDto>;
  createGame(params: { payload: GameCreateRequest }): Promise<GameDto>;
  updateGame(params: { gameId: string; payload: GameUpdateRequest }): Promise<GameDto>;
  deleteGame(params: { gameId: string }): Promise<void>;
  listGameTags(): Promise<GameTagDto[]>;
  searchGameTags(params: { query: string }): Promise<GameTagDto[]>;
  getFavoriteGames(): Promise<GamesListResponse>;
  isGameFavorite(params: { gameId: string }): Promise<boolean>;
  addGameFavorite(params: { gameId: string }): Promise<void>;
  removeGameFavorite(params: { gameId: string }): Promise<void>;
  importGame(params: { source: string; identifier: string }): Promise<GameImportDto>;
}

export class ApiGamesRepository implements GamesRepository {
  async listGames(params?: { name?: string; tags?: string[] }): Promise<GamesListResponse> {
    return endpoints.listGames(params);
  }

  async getGame(params: { gameId: string }): Promise<GameDto> {
    return endpoints.getGame(params.gameId);
  }

  async createGame(params: { payload: GameCreateRequest }): Promise<GameDto> {
    return endpoints.createGame(params.payload);
  }

  async updateGame(params: { gameId: string; payload: GameUpdateRequest }): Promise<GameDto> {
    return endpoints.updateGame(params.gameId, params.payload);
  }

  async deleteGame(params: { gameId: string }): Promise<void> {
    return endpoints.deleteGame(params.gameId);
  }

  async listGameTags(): Promise<GameTagDto[]> {
    return endpoints.listGameTags();
  }

  async searchGameTags(params: { query: string }): Promise<GameTagDto[]> {
    return endpoints.searchGameTags(params.query);
  }

  async getFavoriteGames(): Promise<GamesListResponse> {
    return endpoints.getFavoriteGames();
  }

  async isGameFavorite(params: { gameId: string }): Promise<boolean> {
    return endpoints.isGameFavorite(params.gameId);
  }

  async addGameFavorite(params: { gameId: string }): Promise<void> {
    return endpoints.addGameFavorite(params.gameId);
  }

  async removeGameFavorite(params: { gameId: string }): Promise<void> {
    return endpoints.removeGameFavorite(params.gameId);
  }

  async importGame(params: { source: string; identifier: string }): Promise<GameImportDto> {
    return endpoints.importGame(params.source, params.identifier);
  }
}
